import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const socialProofPDPSelector = createSelector(testTargetOffersSelector, offers => offers.socialProofPDP || Empty.Object);

export { socialProofPDPSelector };
